// import "../assets/css/style.css";

const logoData = [
  { id: 1, src: "/images/referenceLogos/wt-10-1.png", alt: "Borusan Logo" },
  {
    id: 2,
    src: "/images/referenceLogos/neteller-logo-1.png",
    alt: "İstanbul Bilgi Üniversitesi Logo",
  },
  {
    id: 3,
    src: "/images/referenceLogos/binance-1.png",
    alt: "BookMyShow Logo",
  },
  { id: 4, src: "/images/referenceLogos/visa.png", alt: "Akbank Logo" },
  { id: 5, src: "/images/referenceLogos/pngegg.png", alt: "Akçansa Logo" },
  { id: 6, src: "/images/referenceLogos/skrill-logo-1.png", alt: "Aktaş Logo" },
  { id: 7, src: "/images/referenceLogos/PikPng.com_transparent-png-icons_4195720.png", alt: "Ola Logo" },
  { id: 8, src: "/images/referenceLogos/mastercard-logo-1.png", alt: "Amazon Logo" },
];

const ReferencesSection = () => {
  return (
    <section className="references-section">
      <div className="references-header">
        <h1>Stay Connected with The Pips</h1>
        <p>Get the latest updates on our trading insights, platform features, events, and partnerships, all in one place</p>
      </div>

      <div className="diamond-grid">
        <div className="column column-1">
          <div className="logo-card">
            <img src={logoData[0].src} alt={logoData[0].alt} />
          </div>
        </div>

        <div className="column column-2">
          <div className="logo-card">
            <img src={logoData[1].src} alt={logoData[1].alt} />
          </div>
          <div className="logo-card">
            <img src={logoData[2].src} alt={logoData[2].alt} />
          </div>
        </div>

        <div className="column column-3">
          <div className="logo-card">
            <img src={logoData[3].src} alt={logoData[3].alt} />
          </div>
          <div className="logo-card">
            <img src={logoData[4].src} alt={logoData[4].alt} />
          </div>
          <div className="logo-card">
            <a href="#see-all" className="see-all-card">
              More <span className="arrow">→</span>
            </a>
          </div>
          {/* <div className="logo-card"><img src={logoData[4].src} alt={logoData[4].alt} /></div> */}
        </div>

        <div className="column column-4">
          <div className="logo-card">
            <img src={logoData[5].src} alt={logoData[5].alt} />
          </div>
          <div className="logo-card">
            <img src={logoData[6].src} alt={logoData[6].alt} />
          </div>
        </div>
        <div className="column column-5">
          {/* <div className="logo-card"><img src={logoData[6].src} alt={logoData[6].alt} /></div> */}
          <div className="logo-card">
            <img src={logoData[7].src} alt={logoData[7].alt} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferencesSection;
